export var BucketFileCompression;
(function (BucketFileCompression) {
    BucketFileCompression["BUCKET_FILE_COMPRESSION_NONE"] = "NONE";
    BucketFileCompression["BUCKET_FILE_COMPRESSION_GZIP"] = "GZIP";
    BucketFileCompression["BUCKET_FILE_COMPRESSION_BZIP2"] = "BZIP2";
    BucketFileCompression["BUCKET_FILE_COMPRESSION_XZ"] = "XZ";
    BucketFileCompression["BUCKET_FILE_COMPRESSION_ZSTD"] = "ZSTD";
    BucketFileCompression["BUCKET_FILE_COMPRESSION_UNKNOWN"] = "UNKNOWN";
})(BucketFileCompression || (BucketFileCompression = {}));
